var _defs, _path, _path2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMannequin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ARTWORK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.5,4.5A1.47,1.47,0,0,1,13,5.61V7H11V5.61a1.47,1.47,0,0,1-.5-1.11,1.5,1.5,0,0,1,3,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,8v5H9V8a1,1,0,0,1,1-1h4A1,1,0,0,1,15,8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15 12.99 14 18 14 21 12 21 12 12.99 15 12.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12 12.99 12 21 10 21 10 18 9 12.99 12 12.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMannequin);
export default __webpack_public_path__ + "static/media/mannequin.23b34d724ff2234d51a2d014ce836924.svg";
export { ForwardRef as ReactComponent };